import { Component, Input } from '@angular/core';
import { AssistenzaService, IRicercaTotaliTipoAssistenzaParams } from '@app/shared/services/assistenza.service';
import { UtilityService } from '@app/shared/services/utility.service';
import { WidgetCassaType } from '../widget-cassa/widget-cassa.component';
import { ITotaleTipoAssistenza, TipoAssistenza } from '@app/shared/models/assistenza';
import { StazioneService } from '@app/shared/services/stazione.service';
import { IStazione } from '@app/shared/models/stazione';

@Component({
  selector: 'ser-totali-stazione-badge',
  templateUrl: './totali-stazione-badge.component.html',
  styleUrl: './totali-stazione-badge.component.scss'
})
export class TotaliStazioneBadgeComponent {

  @Input() set idStazione(newValue: string) {
    this._idStazione = newValue;
    this.searchTotali();
    this.getDettaglioStazione();
  }

  @Input() set dataDa(newValue: Date) {
    this._dataDa = newValue;
    this.searchTotali();
  }

  @Input() set dataA(newValue: Date) {
    this._dataA = newValue;
    this.searchTotali();
  }

  @Input() widgetMode: boolean = false;

  _idUtente: string;
  _idStazione: string;
  _dataDa: Date;
  _dataA: Date;

  widgetCassaType = WidgetCassaType;

  totali: ITotaleTipoAssistenza[] = [];
  totUscite: number = 0;
  totRitrovato: number = 0;


  stazione: IStazione;

  constructor(private assistenzaService: AssistenzaService, private stazioneService: StazioneService, private utility: UtilityService) { }

  searchTotali() {

    if (!this._idStazione || !this._dataDa || !this._dataA) {
      return
    }

    const params: IRicercaTotaliTipoAssistenzaParams = {
      idStazione: this._idStazione,
      //idOperatore: '',
      dataDa: this.utility.UTCDateFromLocal(this._dataDa),
      dataA: this.utility.UTCDateFromLocal(this._dataA, true)
    }

    this.assistenzaService.ricercaTotali(params).subscribe(totali => {

      this.totali = totali;
      this.totRitrovato = totali.find(tipo => tipo.tipo == TipoAssistenza.DenaroRitrovato)?.importo ?? 0;
      this.totUscite = totali.filter(tipo => tipo.tipo == TipoAssistenza.RimborsoScontriniDiCredito || tipo.tipo == TipoAssistenza.AssistenzaCasse).map(tipo => tipo.importo).reduce((sum, val) => sum + val, 0);

    })

  }

  getDettaglioStazione() {

    if (!this._idStazione) {
      return
    }

    this.stazioneService.dettaglio(this._idStazione).subscribe(stazione => {
      this.stazione = stazione;
    })

  }

}
